<footer class="border-t border-slate-100 dark:border-slate-800/60 bg-white dark:bg-slate-900 px-6 py-3 flex items-center justify-end gap-4 text-xs text-slate-400 dark:text-slate-600 flex-shrink-0">
  <app-latest-versions #versionsComponent></app-latest-versions>
  <span>
    © Ingeniería Gallega de Software SL – {{ currentYear }}
    <a class="text-blue-500 hover:text-blue-700 dark:text-blue-400 cursor-pointer ml-1" (click)="openVersions()">
      v{{ currentApplicationVersion }}
    </a>
  </span>
</footer>